/**
 * VideoEmptyValidator class is responsible for validating if a video model is empty.
 * It uses Angular's $translate service to handle error messages.
 */
class VideoEmptyValidator {
    /**
     * Constructs a new VideoEmptyValidator instance.
     * @param {Object} $injector - Angular's injector service.
     * @param {Object} model - The video model to be validated.
     */
    constructor($injector, model) {
        this.$injector = $injector;
        this.model = model;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.VIDEO';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazy-loads the $translate service from the injector.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the video model.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If the model is empty and has no parents, it's not considered an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            isError,
            'status':           isError ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The translated error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced validation check is requested.
     * @returns {boolean} True if a forced check is requested, otherwise false.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'VideoEmptyValidator';
    }
}

export default VideoEmptyValidator;